/**
 * _support_api.js — the one request helper of the support controllers for
 * /api/support.
 *
 * Sends the page's CSRF token on every request and JSON's content type for a
 * string body (a FormData body sets its own). Resolves with the parsed JSON;
 * a non-2xx answer rejects with the server's error message and its per-field
 * details (the API's error envelope, application/api/support.py), so callers
 * can show them as is. Used by support_chat, support_inbox and
 * support_settings.
 */

function csrfToken() {
    return document.querySelector('meta[name=csrf-token]')?.getAttribute('content') || '';
}

export async function supportRequest(api, method, path, body) {
    const headers = { 'X-CSRFToken': csrfToken() };
    if (typeof body === 'string') headers['Content-Type'] = 'application/json';
    const response = await fetch(`${api}${path}`, {
        method, headers, body, credentials: 'same-origin',
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(data.error || `Request failed (${response.status})`);
        error.details = data.details;   // per-field messages on a 400
        throw error;
    }
    return data;
}
